<template>
  <div id="app" :class="[lang == 'zh' ? 'zh' : 'en']">
    <router-view></router-view>
  </div>
</template>
<script>

export default {
  data(){
    return {
    }
  },
  computed: {
    lang() {
      return this.$i18n.locale
    }
  },
  methods:{
    saveVuexState() {
      if (sessionStorage.getItem('store')) {
        this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
      }
      window.addEventListener('beforeunload', () => {
        sessionStorage.setItem('store', JSON.stringify(this.$store.state))
      })
    },
  },
  created() {
    //页面刷新保留store信息
    this.saveVuexState()
    console.log(this.lang)
  }
}
</script>
<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.en {
  font-size: 18px;
}
.zh {
  font-size: 20px;
}
</style>
